<script>
import { Line, mixins } from "vue-chartjs";

export default {
    extends: Line,
    props: ["chartOption"],
    mixins: [mixins.reactiveProp],
    data(){
        return {
            options: this.chartOption
        }
    },
    mounted() {
        this.options.scales = {
            yAxes: [{
                ticks: {
                    callback: function(value, index, values) {
                        return value.toLocaleString()
                    },
                    fontColor:this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'

                }
            }],
            xAxes : [{
                ticks: {
                    fontColor:this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                }
            }]
        }
        this.options.tooltips = {
            callbacks: {
                label: function(tooltipItem, chart){
                    var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                    return datasetLabel + ': ' + tooltipItem.yLabel.toLocaleString();
                }
            }
        }
        this.renderChart(
        this.chartData, this.options
        )
    },
    watch:{
        "$store.state.theme"(){
            this.options.scales = {
            yAxes: [{
                ticks: {
                    callback: function(value, index, values) {
                        return value.toLocaleString()
                    },
                    fontColor:this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'

                }
            }],
            xAxes : [{
                ticks: {
                    fontColor:this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                }
            }]
        }
            this.renderChart(
                this.chartData, this.options
            )
        }
    }
}

</script>